import configList from '../config/micro-front-list.json';
const listOffEventListener = {};
function filterHref(href) {
    return href.split('?')[0].split('#')[0];
}
function messageListener({ source, data }, expectedHref, callback) {
    const currentHref = filterHref(source.location.href);
    if (currentHref.includes(expectedHref) && callback)
        callback(data);
}
export function getMessageFromIframe(expectedHref, callback, uniqObject) {
    const filter_expectedHref = filterHref(expectedHref);
    const eventListener = ({ source, data }) => messageListener({ source, data }, filter_expectedHref, callback);
    const callbackHash = uniqObject || 'defaultCallback';
    if (!listOffEventListener[filter_expectedHref])
        listOffEventListener[filter_expectedHref] = {};
    listOffEventListener[filter_expectedHref][callbackHash] = eventListener;
    window.addEventListener('message', eventListener);
}
export function removeMessageFromIframe(expectedHref, uniqObject) {
    const eventListener = listOffEventListener[filterHref(expectedHref)]?.[uniqObject || 'defaultCallback'];
    window.removeEventListener('message', eventListener);
}
export function postMessageToChild(childName, data) {
    const iframeElementId = configList[childName]?.elementId;
    if (!iframeElementId)
        return;
    const iframeElementDOM = document.querySelector('#' + iframeElementId);
    if (!iframeElementDOM)
        return;
    iframeElementDOM.contentWindow ? iframeElementDOM.contentWindow.postMessage(data, '*') : window.postMessage(data, '*');
}
//# sourceMappingURL=infrastructure.js.map